<!--主播信息栏-->
<template>
  <div class="gift-panel" :style="panelStyle" @click.prevent.stop>
    <div class="gift-panel-header">
      <div class="gift-catgory active">{{$t('gift.all')}}</div>
    </div>
    <div class="gift-panel-body">
      <div v-for="item in list" :key="item.id" class="gift-item-wrapper" :class="itemWrapperClass">
        <gift-item :gift-item-data="item" v-bind="$attrs" />
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>
import { computed } from 'vue';
import GiftItem from './gift-item.vue';
import { IGiftItem } from './gift-types';

const props = defineProps<{
  list: IGiftItem[];
  panelRowCount: number;
  height: number;
}>();

const panelStyle = computed(() => {
  const width = props.panelRowCount * 80 + (props.panelRowCount - 1) * 12 + 20 + 6;
  return { width: width + 'px', height: props.height + 'px' };
});

const itemWrapperClass = computed(() => {
  return `row-${props.panelRowCount}`;
});
</script>


<style lang="less" scoped>
.gift-panel {
  width: 380px;
  height: 316px;
  background: #fff;
  border: 1px solid rgba(153, 153, 153, 0.2);
  box-shadow: 0 4px 10px 0 rgba(153, 153, 153, 0.2);
  border-radius: 6px;

  .gift-panel-header {
    height: 38px;
    padding: 0 12px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);

    .gift-catgory {
      font-size: 14px;
      color: #999;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
      line-height: 38px;

      &.active {
        color: #4c93ff;
        font-weight: 700;
      }
    }
  }

  .gift-panel-body {
    height: 276px;
    padding: 12px 10px;
    overflow-y: auto;

    .gift-item-wrapper {
      display: inline-block;

      &.row-3 {
        &:nth-child(n + 4) {
          margin-top: 16px;
        }

        &:not(:nth-child(3n + 1)) {
          margin-left: 12px;
        }
      }

      &.row-4 {
        &:nth-child(n + 5) {
          margin-top: 16px;
        }

        &:not(:nth-child(4n + 1)) {
          margin-left: 12px;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 4px;
  background: #fff;
  border-radius: 2px;
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.9);
  border-radius: 2px;
  width: 4px;
  height: 60px;
}
</style>
